<p>
  If you enter a departure date, it assumes that at this date your service,
  salary increase, and other annual increases will stop. Departure date should
  fall before age 55.
</p>
